import "./style.css";
import Form from "@/components/Form";

export default class SampleForm {
  static selector = ".sample-form";

  constructor(block) {
    this.block = block;
    this.formElement = this.block.querySelector(".form");
    this.emailField = this.block.querySelector(".sample-form__email-field");

    this.submitButton = this.block.querySelector(".sample-form__submit");

    this.form = new Form(this.formElement, {
      onSubmitSucceeded: this.handleSubmitSucceeded,
      resetAfterSubmit: false,
      gainControlOnSubmitSucceeded: false,
    });
  }

  handleEmailChange = () => {
    if (this.emailField.validity.valid) {
      this.submitButton.removeAttribute("disabled");
    } else {
      this.submitButton.setAttribute("disabled", "");
    }
  };

  handleSubmitSucceeded = (response) => {
    console.log(response);
  };

  // Public methods
  onReady() {
    this.emailField.addEventListener("change", this.handleEmailChange);
  }
  onComplete() {}
  onResize() {}
  onScroll() {}
  onDestroy() {
    this.emailField.removeEventListener("change", this.handleEmailChange);
  }
}
